export default __webpack_public_path__ + "static/media/Death Harp of the Nine Stars.a7a59f85.jpg";